"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("../../utils/styled-components"));
var CatSport32 = function (props) { return (react_1.default.createElement("svg", __assign({ viewBox: "0 0 32 32", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }, props),
    react_1.default.createElement("path", { d: "M27.067 16.817l-2.305-1.811-5.012 3.007-.899 4.764 3.581 2.533 3.805-2.124.831-6.369zm1.016-.058l-.577 4.423a12.645 12.645 0 001.193-5.382l-.001-.149-.616 1.108zm-9.925 6.753l-4.948.367-1.662 3.075 1.723 1.253a12.776 12.776 0 007.381-.585l1.063-1.594-3.556-2.515zm1.125-6.385l4.989-2.993-.442-4.512-5.611-2.851-3.886 2.296.636 5.814 4.315 2.247zm-.715-11.301l5.792 2.943 1.888-.472a12.691 12.691 0 00-9.091-5.146l1.411 2.674zM9.715 7.872l-4.207 3.841.179 4.74 4.799 1.866 3.49-3.311-.639-5.842-3.622-1.294zm-.527-.873l1.197-2.593a12.745 12.745 0 00-6.058 6.382l.542.155 4.319-3.944zM5.433 17.427l-1.4 2.635a12.724 12.724 0 003.477 5.183l3.16 1.229 1.665-3.081-2.094-4.096-4.808-1.87zm7.426 11.711C6.807 27.718 2.3 22.285 2.3 15.8c0-1.622.282-3.178.799-4.622l.001-.084a.498.498 0 01.171-.371 13.74 13.74 0 017.823-7.718.507.507 0 01.225-.098l.07-.011a13.672 13.672 0 014.863-.793.456.456 0 01.117.003A13.687 13.687 0 0127.4 8.202a.502.502 0 01.167.223l.031.082a13.606 13.606 0 011.928 5.109l.041.109a.5.5 0 01.018.296c.076.583.115 1.177.115 1.78 0 7.566-6.134 13.7-13.7 13.7-.976 0-1.929-.102-2.847-.296a.512.512 0 01-.283-.06l-.011-.006z" }))); };
var StyledCatSport32 = styled_components_1.default(CatSport32)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"], ["\n  width: ", ";\n  height: ", ";\n  color: ", ";\n  vertical-align: middle;\n  fill: ", ";\n\n  ", "\n"])), function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var _b = _a.size, size = _b === void 0 ? '32px' : _b;
    return size;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var color = _a.color, theme = _a.theme;
    return color || theme.base.color.text;
}, function (_a) {
    var stroke = _a.stroke;
    return stroke && "stroke: " + stroke + "; stroke-width: 64;";
});
exports.default = StyledCatSport32;
var templateObject_1;
//# sourceMappingURL=CatSport32.js.map